import React, { useState, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { Card, CardBody, Row, Col } from "reactstrap";
import Common from "../Common";
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import { cardData } from './Constants';
import { isMobile, showToast, confirmBox, checkIntegrationStatus } from "../../Common/Appcommon";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import requestApiService from "../../services/requestApi.service";
import GoogleCalendar from "./GoogleCalendar";
import Cal from './Cal.js';
import Twilio from './Twilio.js';
import Email from './Email.js';
import GoHighlevel from './GoHighlevel.js';
import ModalContent from './IntergationModal.js';
import ZohoCRM from "./ZohoCrm.js";
import HubSpotCRM from "./HubSpotCRM.js";
import BiginCRM from "./BiginCRM.js";
import Make from "./Make.js";
import Zapier from "./Zapier.js";
import N8N from "./N8N.js";
import SalesForce from "./SalesForceCRM";

const Integrations = (props) => {
    const { type } = useParams();
    const [rows, setRows] = useState([]);
    const [DetailsKey, setDetailsKey] = useState('');
    const [IntegrationsKey, setIntegrationsKey] = useState({});
    const [errorMessage, seterrorMessage] = useState('');
    const [buttonStatusValues, setButtonStatusValues] = useState([]);
    const [installedButton, setShowInstalledButton] = useState([]);
    const [setBtn, setInstallBtn] = useState([]);
    const [showButtonLoading, setButtonLoading] = useState('');
    const [googleIntegration, setGoogleIntegrations] = useState(false);
    const [ghlIntegration, setGHLIntegrations] = useState(false);
    const [zohoCrm, setZohoCrm] = useState(false);
    const [hubspotCrm, setHubspotCrm] = useState(false);
    const [biginCrm, setBiginCrm] = useState(false);
    const [make,setMake] = useState(false);
    const [zapier,setZapier] = useState(false);
    const [n8n,setN8N] = useState(false);
    const [salesForceCRM,setsalesForceCRM] = useState(false);

    const [name, setName] = useState('');
    const [isModalOpen, setShowModule] = useState(false);
    const mobile = isMobile();
    const getTitleBody = (showDetailed = false) => {
        return showDetailed ? null : (
            <div>
                <a className="cursor-pointer" onClick={onBackAction}>
                    <span className="d-flex align-center">
                        <i className="fi fi-br-arrow-left pr-1"></i>
                        <span>Back</span>
                    </span>
                </a>
            </div>
        );
    };

    useEffect(() => {
        (async () => {
            setRows(cardData);
            let data = await checkIntegrationStatus();
            setShowInstalledButton(data);
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, [setBtn]);

    const openModule = (Modulekey) => {
        if(Modulekey === 'gcalendar'){
            window.location.hash = `#/integrations/google-calendar`;
        }
        window.location.hash = `#/integrations/${Modulekey}`;
    }
    const onBackAction = () => {
        window.location.hash = `#/integrations`;
        setGHLIntegrations(false);
        setZohoCrm(false);
        setHubspotCrm(false);
        setBiginCrm(false);
        setsalesForceCRM(false)
    }



    const openInstalation = (key, show = false) => {
        const googleKeys = ['google-calendar', 'gcalendar'];
        const ghlKeys = ['ghl_calendar'];
        const crmIntegrations = ['zoho', 'bigin', 'hubspot','make','zapier','n8n','salesforce'];
        const crmSetters = { zoho: setZohoCrm, hubspot: setHubspotCrm, bigin: setBiginCrm,make: setMake,zapier: setZapier,n8n: setN8N,salesForceCRM:setsalesForceCRM };
        if (googleKeys.includes(key)) {
            setName(key);
            setGoogleIntegrations(true);
            IntegrationConfigView();
        } else if (ghlKeys.includes(key)) {
            setName(key);
            setGHLIntegrations(true);
            window.location.hash = `#/integrations/${key}`;
            IntegrationConfigView();
        } else if (crmIntegrations.includes(key)) {
            setName(key);
            if (crmSetters[key]) {
            crmSetters[key](true);
            }
            window.location.hash = `#/integrations/${key}`;
            IntegrationConfigView();
        } else {
            setButtonStatusValues(key);
            setDetailsKey(key);
            setName(key);
            setShowModule((prevState) => !prevState);
        }
    };

    const handleInputChange = (e, field) => {
        let value; // = e.target.value;
        if (e && e.value) {
            value = e.value;
        } else if (e && e.target) {
            // For regular Input field, the value is inside `e.target.value`
            value = e.target.value;
        }

        setIntegrationsKey((prev) => ({
            ...prev,
            [field]: value
        }));
        if(value.trim() !== '' && value !== ''){
            seterrorMessage('');
            setButtonLoading(false);
        }
    };

    const connectAPI = async (keyvalue, buttonStatusValues) => {
        const newErrors = {};
        const requiredKeys = ['name', 'password', 'url', 'port', 'protocol','sender','fromaddress'];   
        if(buttonStatusValues === 'email'){
            const missingKeys = requiredKeys.filter(key => !(key in keyvalue));
            if (missingKeys.length > 0) {
                missingKeys.forEach(key => {
                    newErrors[key] = `${key} is required`;
                });
            }
        }
        Object.entries(keyvalue).forEach(([key, value]) => {
            const isEmptyObject = typeof value === 'object' && value !== null && Object.keys(value).length === 0;
            const isEmptyString = typeof value === 'string' && value.trim() === '';            
            if (value == null || isEmptyString || isEmptyObject) {
                newErrors[key] = `${key} is required and cannot be empty`;
            }
        });
        if (Object.keys(newErrors).length > 0) {
          seterrorMessage(newErrors);
          return;
        } else {
            if (keyvalue !== '' && keyvalue !== null & keyvalue !== undefined) {
                setButtonLoading(true);
                let namevalue = name;
                let params = {
                    ENTITY: "AIPROCESSOR",
                    OPERATION: "CONNECT_INTEGRATIONS",
                    FORMNAME: 'vm_integrations',
                    name: namevalue,
                    details: { type: buttonStatusValues, data: keyvalue },//{type: buttonStatusValues,api_key: keyvalue,},         
                };
                let formresponse = await requestApiService.processServerRequest(params, "WebV2");
                if (formresponse.issuccess) {
                    setInstallBtn('');
                    closeModal();
                    showToast("Installed successfully.");
                } else if (formresponse.errormsg) {
                    seterrorMessage(formresponse.errormsg);
                    setButtonLoading(false);
                }
            } else {
                if(buttonStatusValues === "email"){
                    seterrorMessage('Above All Fields are required.');
                    setButtonLoading(false);
                }else{
                    seterrorMessage('API key is required.');
                    setButtonLoading(false);
                }
            }
        }
        setButtonLoading(false);
    }

    const unInstallIntegrations = async (namevalue,id) => {
        let confirm = await confirmBox("Are you sure want to Uninstall " + namevalue + "?", "Uninstalling the " + namevalue + " app all actions linked to it will stop working.", 'warning', 'Uninstall', 'Cancel');
        if (!confirm) {
            return;
        }
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "UNINSTALL_INTEGRATIONS",
            FORMNAME: 'vm_integrations',
            name: namevalue,
            id: id,
        };
        let formresponse = await requestApiService.processServerRequest(params, "WebV2");
        if (formresponse.issuccess) {
            setInstallBtn(buttonStatusValues);
            showToast("Uninstalled successfully.");
        }
    }

    const closeModal = () => {
        setShowModule((prevState) => !prevState);
        setIntegrationsKey('');
        seterrorMessage('');
        setButtonLoading(false);
    }


    const IntegrationsListView = () => {
        const allIntegrations = [ googleIntegration, ghlIntegration, zohoCrm, biginCrm, hubspotCrm,];
        if ((type === '' || type === undefined) && allIntegrations.every(val => !val)) {
            return (
                <Fragment>
                    <div className="integration-card">
                        {<Row>
                            {rows.map((card, index) => (
                                <Col key={index} className="p-2-1 pb-2 mb-3" md={4} xs={0} sm={0} lg={0}>
                                    <Card className="card-br">
                                        <CardBody>
                                            <Row className={`${!mobile ? "" : "mb-4"}`}>
                                                {!mobile ? (
                                                    <>
                                                        <Col md={3}>
                                                            <img src={card.img} alt={card.heading} className="intagration-card-img" />
                                                        </Col>
                                                        <Col md={9} className="ps-0">
                                                            <div>
                                                                <span className="intagration-card-heading">
                                                                    {card.heading}
                                                                </span>
                                                            </div>
                                                            <span className="intagration-card-subheading">
                                                                {card.subheading}
                                                            </span>
                                                        </Col>
                                                        <Col md={12}>
                                                            <div className="intagration-card-description">
                                                                {card.discription}
                                                            </div>
                                                        </Col>
                                                        {card.component ? (
                                                            <>
                                                                <Col md={12} className="justify-center d-flex">
                                                                    {
                                                                        card.component.button.details && 
                                                                        <div className="justify-center d-flex ms-auto">
                                                                            <Button
                                                                                onClick={() => openModule(card.name)}
                                                                                className="custom-btn-1 btn btn-dark p-2 d-flex align-center"
                                                                            >
                                                                                <i class="fi fi-rr-angle-double-small-right"></i>&nbsp;
                                                                                {/* <FontAwesomeIcon icon={faPlus} />  */}
                                                                                {card.component.button.details}
                                                                            </Button>
                                                                        </div>  
                                                                    }                                                                  
                                                                    {
                                                                        card.component.button.install &&
                                                                        <div className="justify-center d-flex ms-auto">
                                                                            {
                                                                                !installedButton.includes(card.name) ? ( //component.button.key
                                                                                    <Button
                                                                                        onClick={() => openInstalation(card.name, true,)}
                                                                                        // className="custom-btn-1 btn btn-dark p-2"
                                                                                        className="theme-bg-g btn-hover-shine p-2"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faPlus} /> {card.component.button.install}
                                                                                    </Button>
                                                                                ) : (
                                                                                    <div className="intagration-comingsoon">
                                                                                        Installed
                                                                                    </div>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    }
                                                                </Col>
                                                            </>
                                                        ) : (
                                                            <Col md={12} className="text-center">
                                                                <div className="intagration-comingsoon">
                                                                    Coming Soon
                                                                </div>
                                                            </Col>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* <Col className="w-25"> */}
                                                        <div className="mobile-img">
                                                            <img src={card.img} alt={card.heading} className="intagration-card-img" />
                                                        </div>
                                                        {/*  </Col> */}
                                                        <Col md={9} className="mt-1-1 ms-1 w-75" style={{ height: "95px" }}>
                                                            <div className="card-fields d-grid justify-start ms-2">
                                                                <span className="intagration-card-heading">
                                                                    {card.heading}
                                                                </span>
                                                                <span className="intagration-card-subheading">
                                                                    {card.subheading}
                                                                </span>
                                                            </div>
                                                            <Row className="p-1">
                                                                <div className="intagration-card-description p-3 mb-4">
                                                                    {card.discription}
                                                                </div>
                                                            </Row>
                                                        </Col>
                                                        <Row className="mt-4">
                                                            {
                                                                card.component ? (
                                                                    <>
                                                                        <Col className="w-100">
                                                                            {
                                                                                installedButton.includes(card.heading) ? (
                                                                                    <div className="intagration-comingsoon">
                                                                                        Installed
                                                                                    </div>
                                                                                ) : (
                                                                                    <Button
                                                                                        onClick={() => openModule(card.name)}
                                                                                        className="custom-btn-1 btn btn-dark p-1 d-flex ms-auto mt-1"
                                                                                    >
                                                                                        <i class="fi fi-rr-angle-double-small-right"></i>&nbsp;{card.component.button.details}
                                                                                    </Button>
                                                                                )
                                                                            }
                                                                        </Col>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Col className="w-100 ms-2">
                                                                            <div className="intagration-comingsoon mb-2">
                                                                                Coming Soon
                                                                            </div>
                                                                        </Col>
                                                                    </>
                                                                )
                                                            }
                                                        </Row>
                                                    </>
                                                )}
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>}
                    </div>
                </Fragment>
            )
        }
    }

    const IntegrationConfigView = () => {
        if (type === 'gcalendar' || googleIntegration === true || type === 'google-calendar') {
            return (<GoogleCalendar name={"gcalendar"} install={googleIntegration} buttonValue={installedButton} installedButton={setInstallBtn}></GoogleCalendar>); // install={googleIntegration}
        } else if (type === 'cal.com') {
            return (<Cal name={"cal.com"} isInstalation={openInstalation} buttonValue={installedButton} unInstall={unInstallIntegrations} ></Cal>);
        } else if (type === 'twilio') {
            return (<Twilio name={"twilio"} isInstalation={openInstalation} buttonValue={installedButton} unInstall={unInstallIntegrations}></Twilio>);
        } else if (type === 'email') {
            return (<Email name={"email"} isInstalation={openInstalation} buttonValue={installedButton} unInstall={unInstallIntegrations}></Email>);
        } else if (type === 'ghl_calendar' || ghlIntegration === true || type === 'highlevel') {
            return (<GoHighlevel name={"ghl_calendar"} install={ghlIntegration} buttonValue={installedButton} unInstall={unInstallIntegrations}/>); // </GoHighlevel>
        } else if (type === 'zoho'|| zohoCrm === true) {
            return (<ZohoCRM name={"zoho"} install={zohoCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>); 
        }else if (type === 'hubspot' || hubspotCrm === true) {
            return (<HubSpotCRM name={"hubspot"} install={hubspotCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>);
        }else if (type === 'bigin' || biginCrm === true) {
            return (<BiginCRM name={"bigin"} install={biginCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>);
        }else if (type === 'make' || make === true) {
            return (<Make name={"make"} install={biginCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>);
        }else if (type === 'zapier' || zapier === true) {
            return (<Zapier name={"zapier"} install={biginCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>);
        }else if (type === 'n8n' || n8n === true) {
            return (<N8N name={"n8n"} install={biginCrm} buttonValue={installedButton} unInstall={unInstallIntegrations}/>);
        }else if(type === 'salesforce'){
            return (<SalesForce name={"salesforce"} install={salesForceCRM} buttonValue={installedButton} unInstall={unInstallIntegrations} installedButton={setInstallBtn}/>); 
        }
    }

    return (
        <Fragment>
            <Common
                title="Integrations"
                titleContent={
                    (!type) ? (
                        <span>Integrations</span>
                    ) : (
                        <a className="cursor-pointer" onClick={onBackAction}>
                            <span className="d-flex align-center">
                                <i className="fi fi-br-arrow-left pr-1"></i>
                                <span>Integrations</span>
                            </span>
                        </a>
                    )
                }
                titleBody={(isMobile() && !!type) && getTitleBody()}
                mainContent={
                    <div className="w-100">
                        {
                            IntegrationsListView() ?? IntegrationConfigView()
                        }
                        {
                            isModalOpen &&
                            <ModalContent
                                isModalOpen={isModalOpen}
                                closeModal={closeModal}
                                DetailsKey={DetailsKey}
                                IntegrationsKey={IntegrationsKey}
                                setIntegrationsKey={setIntegrationsKey}
                                handleInputChange={handleInputChange}
                                errorMessage={errorMessage}
                                showButtonLoading={showButtonLoading}
                                connectAPI={connectAPI}
                                buttonStatusValues={buttonStatusValues}
                                buttonValue={installedButton}
                            />
                        }
                    </div>
                }
                titleKey={"integrations_allowed"}  
            />
        </Fragment>
    );
};


const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);
